import { AppPageHeader } from '@/components/_common';
import { ListPaymentConditionsQuery } from '@/core/domain/enterprise/PaymentCondition/PaymentCondition.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import PaymentsConditionExtraFilters from '../PaymentsConditionExtraFilters';

const PaymentsConditionFilters: React.FC<
  ExtraFiltersProps<ListPaymentConditionsQuery>
> = ({ queryParams, setQueryParams }) => {
  return (
    <AppPageHeader
      onSearch={(value) => setQueryParams((prev) => ({ ...prev, name: value }))}
      searchValue={queryParams?.name}
      extraFilters={
        <PaymentsConditionExtraFilters
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      }
    />
  );
};

export default PaymentsConditionFilters;
